import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { serviceUrl } from '../common/serviceconstants';
import { Router, ActivatedRoute } from '@angular/router';
import { GenericHttpClient } from '../Services/Basicauthentication';
import { UtilityServices } from '../UtilityServices';
import { CurrencyPipe } from '@angular/common'
import { ThrowStmt } from '@angular/compiler';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-gross-proceeds-budget',
  templateUrl: './gross-proceeds-budget.component.html',
  styleUrls: ['./gross-proceeds-budget.component.scss']
})
export class GrossProceedsBudgetComponent implements OnInit {
  gmessage: any;
  budgetamount: any;
  bbudgetamount: any;
  userid: any;
  isadmin: any = false;

  constructor(private http: HttpClient, private router: Router, private httpClient: GenericHttpClient,
    private utility: UtilityServices, private cp: CurrencyPipe) {
    const userid = sessionStorage.getItem('UserID');
    if (userid === '' || userid === null) {


    } else {
      // this.IsAdmin = true;
      this.userid = userid;
    }
    // this.getprojectamounts();
    let a = sessionStorage.getItem("Admin");
    if (a && a === "True") {
      this.isadmin = true;
    } else {
      this.router.navigateByUrl('/dashboard');
    }
  }

  ngOnInit(): void {
  }
  grossbudgetamount: any;

  GetProjectGrossBudgetAmount() {
    this.http.get(serviceUrl + '/Project/GetProjectGrossBudgetAmount',
      { params: {} }).toPromise<any>().then(response => {
        this.grossbudgetamount = response;
      });
  }
  CloseBudgetInfo() {
    this.router.navigateByUrl('/dashboard');
  }


  bmessage: any;
  SaveBudget() {
    if (this.bbudgetamount && this.bbudgetamount.length > 0) {
      const hdrs = new HttpHeaders(
        { 'Content-type': 'application/json' });
      this.http.post<any>(serviceUrl + '/Project/InsertProjectGrossBudgetAmount', {
        ProjectGrossBudgetAmount: this.bbudgetamount,
        CreatedBy: this.userid,
      }, { headers: hdrs }).subscribe(
        res => {

          this.bmessage = 'New Gross Proceeds Budget Amount Successfully Saved.';
          this.bclear();

        },
        err => {


        });
    } else {
      this.bmessage = 'Please enter required fields.';
    }
  }

  bclear() {
    this.bbudgetamount = '';
  }

}
